import { createRedirectUrlPlugin } from '@algolia/autocomplete-plugin-redirect-url';

const redirectUrlPlugin = createRedirectUrlPlugin();

export default redirectUrlPlugin;
